import React from 'react';
export const IconNail = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-208">
    <path d="M12 22c3.5 0 5-3 5-7V7c0-2.5-2-4-5-4S7 4.5 7 7v8c0 4 1.5 7 5 7z" data-id="element-209" />
    <path d="M7 11c0-2 2-3 5-3s5 1 5 3" data-id="element-210" />
    <path d="M12 3v2" strokeLinecap="round" data-id="element-211" />
  </svg>;
export const IconShieldNail = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-212">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-213" />
    <path d="M12 8v4" strokeLinecap="round" data-id="element-214" />
    <path d="M12 16h.01" strokeLinecap="round" strokeWidth="2" data-id="element-215" />
  </svg>;
export const IconPolish = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-216">
    <path d="M15 10V5a1 1 0 00-1-1h-4a1 1 0 00-1 1v5" data-id="element-217" />
    <path d="M17 22H7a2 2 0 01-2-2v-8a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2z" data-id="element-218" />
    <path d="M9 4V2" strokeLinecap="round" data-id="element-219" />
    <path d="M15 4V2" strokeLinecap="round" data-id="element-220" />
    <path d="M12 14v4" strokeLinecap="round" data-id="element-221" />
  </svg>;
export const IconHairStrands = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-222">
    <path d="M8 3c0 4-3 6-3 10s3 6 3 8" strokeLinecap="round" data-id="element-223" />
    <path d="M12 3c0 5-4 7-4 11s4 6 4 7" strokeLinecap="round" data-id="element-224" />
    <path d="M16 3c0 6-5 8-5 12s5 5 5 6" strokeLinecap="round" data-id="element-225" />
  </svg>;
export const IconLeaf = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-226">
    <path d="M12 22c0-4 4-8 8-8-4 0-8-4-8-8 0 4-4 8-8 8 4 0 8 4 8 8z" data-id="element-227" />
    <path d="M12 14v8" strokeLinecap="round" data-id="element-228" />
  </svg>;
export const IconSparkle = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-229">
    <path d="M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2 2-6z" strokeLinejoin="round" data-id="element-230" />
    <path d="M19 17l1 3 3 1-3 1-1 3-1-3-3-1 3-1 1-3z" strokeLinejoin="round" data-id="element-231" />
    <path d="M6 5l.5 1.5L8 7l-1.5.5L6 9l-.5-1.5L4 7l1.5-.5L6 5z" strokeLinejoin="round" data-id="element-232" />
  </svg>;
export const IconStar = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-233">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" strokeLinejoin="round" data-id="element-234" />
  </svg>;
export const IconDiamond = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-235">
    <path d="M12 2L2 9l10 13L22 9l-10-7z" strokeLinejoin="round" data-id="element-236" />
    <path d="M2 9h20" strokeLinecap="round" data-id="element-237" />
    <path d="M12 2v20" strokeLinecap="round" data-id="element-238" />
    <path d="M7 5l-2 4" strokeLinecap="round" data-id="element-239" />
    <path d="M17 5l2 4" strokeLinecap="round" data-id="element-240" />
  </svg>;
export const IconCertificate = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-241">
    <path d="M12 15a4 4 0 100-8 4 4 0 000 8z" data-id="element-242" />
    <path d="M10.5 14.5L8 21l4-2 4 2-2.5-6.5" strokeLinejoin="round" data-id="element-243" />
    <path d="M19 4H5a2 2 0 00-2 2v12a2 2 0 002 2h2" strokeLinecap="round" data-id="element-244" />
    <path d="M19 20h2a2 2 0 002-2V6a2 2 0 00-2-2h-2" strokeLinecap="round" data-id="element-245" />
  </svg>;
export const IconPin = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-246">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" data-id="element-247" />
    <circle cx="12" cy="10" r="3" data-id="element-248" />
  </svg>;
export const IconClock = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-249">
    <circle cx="12" cy="12" r="10" data-id="element-250" />
    <path d="M12 6v6l4 2" strokeLinecap="round" strokeLinejoin="round" data-id="element-251" />
  </svg>;
export const IconInstagram = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-252">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-253" />
    <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" data-id="element-254" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" strokeWidth="2" strokeLinecap="round" data-id="element-255" />
  </svg>;
export const IconLink = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-256">
    <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" strokeLinecap="round" data-id="element-257" />
    <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" strokeLinecap="round" data-id="element-258" />
  </svg>;
export const IconWhatsApp = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} data-id="element-259">
    <path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" strokeLinejoin="round" data-id="element-260" />
    <path d="M9 10a.5.5 0 001 0V9a.5.5 0 00-1 0v1a5 5 0 005 5h1a.5.5 0 000-1h-1a.5.5 0 01-5-5z" strokeLinecap="round" strokeLinejoin="round" data-id="element-261" />
  </svg>;
export const IconMonogram = ({
  className = 'w-12 h-12'
}: {
  className?: string;
}) => <svg viewBox="0 0 100 100" fill="none" className={className} data-id="element-262">
    <circle cx="50" cy="50" r="48" stroke="currentColor" strokeWidth="1" opacity="0.3" data-id="element-263" />
    <text x="50" y="62" fontFamily="Playfair Display, serif" fontSize="42" fontWeight="400" fill="currentColor" textAnchor="middle" letterSpacing="-2" data-id="element-264">
      CF
    </text>
    <path d="M70 30c-2 2-5 1-7-1s-1-5 1-7 5-1 7 1 1 5-1 7z" fill="currentColor" opacity="0.6" data-id="element-265" />
    <path d="M30 70c2-2 5-1 7 1s1 5-1 7-5 1-7-1-1-5 1-7z" fill="currentColor" opacity="0.6" data-id="element-266" />
  </svg>;